import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { ArrowLeft, CalendarDays, Clock } from "lucide-react";
import { toast } from "sonner";

const STATUS = {
  richiesta: { label: "In attesa di conferma", cls: "bg-amber-500/15 text-amber-300" },
  confermata: { label: "Confermata", cls: "bg-[#00E676]/15 text-[#00E676]" },
  rifiutata: { label: "Rifiutata", cls: "bg-zinc-600/30 text-zinc-400" },
  annullata: { label: "Annullata", cls: "bg-red-500/15 text-red-400" },
  completata: { label: "Completata", cls: "bg-sky-500/15 text-sky-300" },
};

export default function CustomerBookings() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const load = async () => { try { const { data } = await api.get("/my/bookings"); setItems(data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };
  useEffect(() => { load(); }, []);
  const cancel = async (id) => { if (!window.confirm("Annullare questa prenotazione?")) return; try { await api.put(`/my/bookings/${id}/cancel`); toast.success("Prenotazione annullata"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white pb-24">
      <header className="sticky top-0 z-10 bg-[#0A0A0C]/90 backdrop-blur-xl border-b border-white/10 px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button data-testid="bookings-back" onClick={() => navigate("/professionisti")} className="text-zinc-400 hover:text-white"><ArrowLeft className="h-5 w-5" /></button>
          <h1 className="font-['Unbounded'] font-extrabold text-lg tracking-tight">Le mie prenotazioni</h1>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-5 space-y-3">
        {items.length === 0 && <div data-testid="my-bookings-empty" className="text-center py-20 text-zinc-500"><CalendarDays className="h-12 w-12 mx-auto mb-3 opacity-40" />Non hai ancora prenotazioni.</div>}
        {items.map((b) => (
          <div key={b.id} data-testid={`my-booking-${b.id}`} className="bg-[#141416] border border-white/10 rounded-2xl p-4">
            <div className="flex items-center justify-between gap-2">
              <span className="font-semibold">{b.professional_name}</span>
              <span className={`text-[10px] rounded-full px-2 py-0.5 ${STATUS[b.status]?.cls}`}>{STATUS[b.status]?.label || b.status}</span>
            </div>
            <div className="text-sm text-zinc-300 mt-1.5 flex items-center gap-2"><Clock className="h-4 w-4 text-[#00E676]" /> {b.date} · {b.start}</div>
            {b.note && <p className="text-sm text-zinc-400 mt-1">{b.note}</p>}
            {["richiesta", "confermata"].includes(b.status) && <Button size="sm" variant="ghost" data-testid={`my-booking-cancel-${b.id}`} onClick={() => cancel(b.id)} className="mt-2 text-red-400 hover:text-red-300 px-0">Annulla</Button>}
          </div>
        ))}
      </div>
    </div>
  );
}
